module.exports = __webpack_public_path__ + "img/bag.c6c57c8a.svg";